<!-- Certificate of Origin Format -->
<div class="coo-container">
  <div class="coo-page" *ngFor="let invoice of invoices; let i = index">

    <!-- Header -->
    <div class="coo-header">
      <div class="header-left">
        <div class="logo-circle">
          <img *ngIf="logoUrl" [src]="logoUrl" alt="Logo"
            style="width: 100%; height: 100%; object-fit: contain;">
          <span *ngIf="!logoUrl" class="logo-text">SMJ</span>
        </div>
      </div>
      <div class="header-center">
        <h1 class="doc-title">CERTIFICATE OF ORIGIN</h1>
      </div>
      <div class="header-right">
        <div class="header-field">
          <span class="field-label">DATE:</span>
          <span class="field-value">{{ formatDate(invoice.invoice_date) }}</span>
        </div>
        <div class="header-field">
          <span class="field-label">INVOICE NO.:</span>
          <span class="field-value">{{ invoice.invoice_number }}</span>
        </div>
        <div class="company-info">
          <p>{{ settings?.company }}</p>
          <p>{{ settings?.city }}, {{ settings?.state }}, JAPAN</p>
          <p>TEL: {{ settings?.telephone }} FAX: {{ settings?.fax }}</p>
        </div>
      </div>
    </div>

    <!-- Buyer & Shipping Info Row -->
    <div class="info-row">
      <div class="buyer-section">
        <div class="section-label">BUYER:</div>
        <div class="section-content">
          <p><strong>{{ invoice.order?.buyer_company_name }}</strong></p>
          <p>{{ invoice.order?.buyer_street_address }}</p>
          <p>{{ invoice.order?.buyer_city }}</p>
          <p>{{ invoice.order?.buyer_country }}</p>
        </div>
      </div>
      <div class="shipping-section">
        <table class="shipping-table">
          <tr>
            <td class="sh-label">PORT OF LOADING:</td>
            <td class="sh-value">{{ invoice.ship?.sailing_port || '-' }}</td>
          </tr>
          <tr>
            <td class="sh-label">PORT OF DISCHARGE:</td>
            <td class="sh-value">{{ invoice.order?.to_port }}, {{ invoice.order?.to_country }}</td>
          </tr>
          <tr>
            <td class="sh-label">VESSEL:</td>
            <td class="sh-value">{{ invoice.ship?.name || '-' }}</td>
          </tr>
          <tr>
            <td class="sh-label">SELLING ON OR ABOUT:</td>
            <td class="sh-value">{{ formatDate(invoice.ship?.sailing_date) }}</td>
          </tr>
        </table>
      </div>
    </div>

    <!-- Vehicle Table -->
    <table class="vehicle-table">
      <thead>
        <tr>
          <th class="col-marks">MARKS AND NUMBERS</th>
          <th class="col-desc">DESCRIPTION OF GOODS</th>
          <th class="col-qty">QTY</th>
          <th class="col-cf">C&amp;F {{ invoice.order?.to_country }}</th>
        </tr>
      </thead>
      <tbody>
        <!-- Individual mode -->
        <ng-container *ngIf="viewMode !== 'merged' || !invoice.vehicles">
          <tr>
            <td class="col-marks">
              {{ invoice.order?.order_number }}<br>
              FAX: {{ settings?.fax }}
            </td>
            <td class="col-desc">
              <p><strong>{{ invoice.vehicle?.make }} {{ invoice.vehicle?.model }} {{ invoice.vehicle?.name }}</strong></p>
              <p>TYPE OF VEHICLE: {{ invoice.vehicle?.body_type || '-' }}</p>
              <p>CHASSIS NO: {{ invoice.vehicle?.chassis_no || invoice.vehicle?.vin_no || '-' }}</p>
              <p>YEAR OF MANUFACTURE: {{ invoice.vehicle?.year || '-' }}</p>
              <p>DATE OF FIRST REGISTRATION: {{ formatRegDate(invoice.vehicle?.reg_year, invoice.vehicle?.reg_month) }}</p>
              <p>BODY COLOR: {{ invoice.vehicle?.exterior_color || '-' }}</p>
              <p>HS CODE: {{ invoice.vehicle?.hs_code || '--' }}</p>
              <p>STEERING: {{ invoice.vehicle?.steering || '-' }}</p>
              <p>FUEL: {{ invoice.vehicle?.fuel_type || '-' }}</p>
              <p>EXPORT INSPECTION CERT NO: {{ invoice.vehicle?.inspection_passed_date || '--' }}</p>
              <p>INSTALLED ACCESSORIES: {{ invoice.vehicle?.stockOptions || '-' }}</p>
              <p>COUNTRY OF ORIGIN: JAPAN</p>
            </td>
            <td class="col-qty">1</td>
            <td class="col-cf">
              <p>(FOB JAPAN)</p>
              <p class="amount">${{ invoice.invoice_amount | number:'1.2-2' }}</p>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>OCEAN FREIGHT</td>
            <td></td>
            <td>${{ invoice.vehicle?.ocean_freight || '0' }}</td>
          </tr>
          <tr>
            <td></td>
            <td>INSURANCE</td>
            <td></td>
            <td>$0</td>
          </tr>
        </ng-container>

        <!-- Merged mode -->
        <ng-container *ngIf="viewMode === 'merged' && invoice.vehicles">
          <tr *ngFor="let vehicle of invoice.vehicles; let vi = index">
            <td class="col-marks">
              {{ invoice.order?.order_number }}<br>
              FAX: {{ settings?.fax }}
            </td>
            <td class="col-desc">
              <p><strong>{{ vehicle.make }} {{ vehicle.model }} {{ vehicle.name }}</strong></p>
              <p>TYPE OF VEHICLE: {{ vehicle.body_type || '-' }}</p>
              <p>CHASSIS NO: {{ vehicle.chassis_no || vehicle.vin_no || '-' }}</p>
              <p>YEAR OF MANUFACTURE: {{ vehicle.year || '-' }}</p>
              <p>DATE OF FIRST REGISTRATION: {{ formatRegDate(vehicle.reg_year, vehicle.reg_month) }}</p>
              <p>BODY COLOR: {{ vehicle.exterior_color || '-' }}</p>
              <p>HS CODE: {{ vehicle.hs_code || '--' }}</p>
              <p>STEERING: {{ vehicle.steering || '-' }}</p>
              <p>FUEL: {{ vehicle.fuel_type || '-' }}</p>
              <p>EXPORT INSPECTION CERT NO: {{ vehicle.inspection_passed_date || '--' }}</p>
              <p>COUNTRY OF ORIGIN: JAPAN</p>
            </td>
            <td class="col-qty">1</td>
            <td class="col-cf">
              <p>(FOB JAPAN)</p>
              <p class="amount">${{ vehicle.invoice_amount | number:'1.2-2' }}</p>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>OCEAN FREIGHT</td>
            <td></td>
            <td>$0</td>
          </tr>
          <tr>
            <td></td>
            <td>INSURANCE</td>
            <td></td>
            <td>$0</td>
          </tr>
        </ng-container>
      </tbody>
      <tfoot>
        <tr class="total-row">
          <td colspan="3">
            TOTAL {{ viewMode === 'merged' && invoice.vehicles ? invoice.vehicles.length : 1 }} UNIT &nbsp;&nbsp;
            INCOTERM 2010 &nbsp;&nbsp; {{ invoice.order?.to_port }} {{ invoice.order?.to_country }}
          </td>
          <td class="total-amount">${{ invoice.invoice_amount | number:'1.2-2' }}</td>
        </tr>
      </tfoot>
    </table>

    <!-- Certification Block -->
    <div class="cert-block">
      <div class="cert-text">
        <p>*WE HEREBY CERTIFYING THAT GOODS COVERED BY THIS CERTIFICATE OF ORIGIN ARE OF JAPANESE ORIGIN
          AND CONFORM TO THE SPECIFICATIONS OF PROFORMA NO. <strong>{{ invoice.order?.order_number }}</strong>
          DATED <strong>{{ formatDate(invoice.invoice_date) }}</strong>
        </p>
        <p>DOCUMENTARY CREDIT NO: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
        <p>DATE OF ISSUE: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
        <p>ISSUED BY: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
      </div>
      <div class="cert-signature">
        <div class="stamp-box">[STAMP]</div>
        <p class="sig-label">AUTHORIZED SIGNATURE</p>
        <p><strong>{{ settings?.company }}</strong></p>
      </div>
    </div>

    <!-- Page Break -->
    <div class="page-break" *ngIf="i < invoices.length - 1"></div>

  </div>
</div>
